import { getBabaPhotoCandidates, handleBabaPhotoError, BABA_PLACEHOLDER } from "../utils/babaPhoto.js";
import { Star } from "lucide-react";

const STATUS = {
  aguardando: { label: "Aguardando", cls: "bg-amber-50 text-amber-600 border-amber-200" },
  em_contato: { label: "Em contato", cls: "bg-blue-50 text-blue-600 border-blue-200" },
  concluida: { label: "Concluída", cls: "bg-emerald-50 text-emerald-600 border-emerald-200" },
  cancelada: { label: "Cancelada", cls: "bg-gray-100 text-gray-500 border-gray-200" },
};

const formatarData = (iso) => {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleDateString("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  } catch {
    return "";
  }
};

export default function CardSolicitacao({ solicitacao, jaAvaliada = false, onAvaliar }) {
  const status = STATUS[solicitacao.status] || STATUS.aguardando;
  const foto = getBabaPhotoCandidates(solicitacao.baba_foto_url)[0] || BABA_PLACEHOLDER;
  const podeAvaliar = solicitacao.status === "concluida" && !jaAvaliada;

  return (
    <div className="flex items-center gap-4 rounded-xl border border-border p-4">
      <img
        src={foto}
        alt={solicitacao.baba_nome || "Babá"}
        className="h-14 w-14 rounded-xl object-cover shrink-0"
        onError={(e) => handleBabaPhotoError(e, getBabaPhotoCandidates(solicitacao.baba_foto_url))}
      />

      <div className="min-w-0 flex-1">
        <p className="text-sm font-semibold text-foreground truncate">
          {solicitacao.baba_nome || "Babá"}
        </p>
        <p className="text-xs text-muted-foreground mt-0.5">
          Solicitado em {formatarData(solicitacao.criado_em)}
        </p>
        <span
          className={`mt-2 inline-block rounded-full border px-2.5 py-0.5 text-[11px] font-semibold ${status.cls}`}
        >
          {status.label}
        </span>
      </div>

      {podeAvaliar && (
        <button
          onClick={() => onAvaliar?.(solicitacao)}
          className="flex items-center gap-1.5 rounded-xl bg-rose-400 px-4 py-2 text-sm font-semibold text-white hover:brightness-105 active:scale-95 transition shrink-0"
        >
          <Star size={14} fill="currentColor" /> Avaliar
        </button>
      )}
      {solicitacao.status === "concluida" && jaAvaliada && (
        <span className="text-xs font-medium text-emerald-600 shrink-0">Avaliada ✓</span>
      )}
    </div>
  );
}
